import React from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import Moment from "react-moment";

export default function OrderStatus(props) {
  return (
    <div>
      {" "}
      <div className="flex items-start gap-x-5">
        <div
          className="bg-white border-2 border-themeBlue min-w-[40px] min-h-[40px] rounded-fullest text-themeBlue sm:flex hidden 
    justify-center items-center mt-1"
        >
          {props.check}
        </div>
        <div className="space-y-2 border-b border-black border-opacity-40 w-full sm:pb-8 pb-4">
          <div>
            <h2 className="font-medium sm:text-2xl text-lg">
              Order {props.status}
            </h2>
            <p className="font-normal sm:text-base text-sm">
              {props?.date ? (
                <Moment format="D MMM , YYYY hh:mm a">{props.date}</Moment>
              ) : (
                ""
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
